import { iteratorSymbol, singleValueIterator } from './iterator';
var lift = function (obj) {
    if (obj instanceof Array)
        return new ArrayOps(obj);
    if (obj instanceof Date)
        return new DateOps(obj);
    if (typeof obj === 'string')
        return new StringOps(obj);
    if (typeof obj === 'number')
        return new NumberOps(obj);
    return new ObjectOps(obj);
};
export default lift;
export function getValue(input) {
    return input && input['_isLiftWrapper']
        ? input.value()
        : input;
}
function makeOps() {
    var Ops = /** @class */ (function () {
        function Ops(_value) {
            this._value = _value;
            this._isLiftWrapper = true;
        }
        Ops.prototype.value = function () { return this._value; };
        return Ops;
    }());
    Ops.prototype[iteratorSymbol] = singleValueIterator(function (self) { return self._value; });
    return Ops;
}
export var ArrayOps = makeOps();
ArrayOps.prototype[iteratorSymbol] = function () {
    var i = 0;
    var self = this;
    return {
        next: function () {
            return i < self._value.length
                ? { value: self._value[i++], done: false }
                : { done: true };
        }
    };
};
export var ObjectOps = makeOps();
export var NumberOps = makeOps();
export var StringOps = makeOps();
export var DateOps = makeOps();
